// extracted by mini-css-extract-plugin
export default {"error":"error---tklt5","editor":"editor---GQlDN"};